import React from "react";
import WidgetCard from "./WidgetCard";
import { Col, Row, Table, Button } from "antd";
import { VisibilityTableColumnKeys } from "@/ts/common-types";

interface IKeywordVisibilityWidget {
    title: string;
    widgetData: any;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    setSelectedKeyword: React.Dispatch<React.SetStateAction<string>>;
}

interface IColumn {
    title: string;
    dataIndex?: string;
    key: string;
    render?: (value: string, record?: any) => JSX.Element;
}

const getRenderClass = (value: string) => {
    return value.includes("-") ? "text-danger" : "text-success";
};

const KeywordVisibilityWidget: React.FC<IKeywordVisibilityWidget> = ({
    title,
    widgetData,
    setShow,
    setSelectedKeyword
}) => {
    const handleComapareClick = (record: any) => {
        setSelectedKeyword(record.title);
        setShow(true);
    };

    const columns: IColumn[] = [
        {
            title: "Title",
            dataIndex: VisibilityTableColumnKeys.Title,
            key: VisibilityTableColumnKeys.Title,
        },
        {
            title: "Indexed (Organic)",
            dataIndex: VisibilityTableColumnKeys.Indexed,
            key: VisibilityTableColumnKeys.Indexed,
        },
        {
            title: "Δ Org. Impr",
            dataIndex: VisibilityTableColumnKeys.DeltaOrganicImpr,
            key: VisibilityTableColumnKeys.DeltaOrganicImpr,
            render: (value: string) => (
                <span className={getRenderClass(value)}>{value}</span>
            ),
        },
        {
            title: "Δ Paid. Impr",
            dataIndex: VisibilityTableColumnKeys.DeltaPaidImpr,
            key: VisibilityTableColumnKeys.DeltaPaidImpr,
            render: (value: string) => (
                <span className={getRenderClass(value)}>{value}</span>
            ),
        },
        {
            title: "Δ Overall. Impr",
            dataIndex: VisibilityTableColumnKeys.DeltaOverallImpr,
            key: VisibilityTableColumnKeys.DeltaOverallImpr,
            render: (value: string) => (
                <span className={getRenderClass(value)}>{value}</span>
            ),
        },
        {
            title: "Org. %Time Page1",
            dataIndex: VisibilityTableColumnKeys.OrganicTimePage1,
            key: VisibilityTableColumnKeys.OrganicTimePage1,
        },
        {
            title: "Org. %Time on Top5 rank",
            dataIndex: VisibilityTableColumnKeys.OrganicTop5Rank,
            key: VisibilityTableColumnKeys.OrganicTop5Rank,
        },
        {
            title: "Spons. %Time Page1",
            dataIndex: VisibilityTableColumnKeys.SponsoredTimePage1,
            key: VisibilityTableColumnKeys.SponsoredTimePage1,
        },
        {
            title: "Spons. %Time Top5 rank",
            dataIndex: VisibilityTableColumnKeys.SponsoredTop5Rank,
            key: VisibilityTableColumnKeys.SponsoredTop5Rank,
        },
        {
            title: "",
            key: VisibilityTableColumnKeys.Action,
            render: (_, record) => (
                <Button
                    type="link"
                    className="fw-normal"
                    onClick={() => handleComapareClick(record)}
                >
                    Compare
                </Button>
            ),
        },
    ];
    
    return (
        <WidgetCard className="my-5">
            <Row className="fs-5 fw-bold mb-3" align="middle">
                <Col span={19}>
                    <h5 className="d-inline-block me-3">
                        {title || "Keyword Visibility"}
                    </h5>
                </Col>
            </Row>
            <Row>
                <Table
                    dataSource={widgetData}
                    columns={columns}
                    pagination={false}
                    scroll={{ y: 400 }}
                />
            </Row>
        </WidgetCard>
    );
};

export default KeywordVisibilityWidget;